// extracted by mini-css-extract-plugin
export default {"bar":"BarGradient_bar__rhw7R"};